import { captureException } from '@sentry/react'

import { SavedState } from '../utils/redirectState'

const IDE_PORT_URL_SEARCH_PARAM_NAME = 'port'
export const IDE_AUTH_URL_PATH_NAME = '/ideauth'
export const IDE_AUTH_ERROR_URL_PATH_NAME = `${IDE_AUTH_URL_PATH_NAME}/error`

export const isIdeAuthRedirectData = (data: SavedState) => {
	return (
		data.pathname === IDE_AUTH_URL_PATH_NAME &&
		new URLSearchParams(data.search).has(IDE_PORT_URL_SEARCH_PARAM_NAME)
	)
}

export const getIdePortFromRedirectData = (data: SavedState) => {
	return new URLSearchParams(data.search).get(IDE_PORT_URL_SEARCH_PARAM_NAME) || ''
}

export const sendLicenceAcceptanceStatusToIde = async (
	port: number,
	userId: string,
	accepted: boolean,
) => {
	const url = new URL(`http://localhost:${port}/api/qodana/license-agreement`)

	const body = JSON.stringify({
		userId,
		accepted,
	})

	// for emergency cases if we cannot connect to IDE for some reasons
	for (let i = 0; i < 3; i++) {
		try {
			const response = await fetch(url.toString(), {
				method: 'POST',
				body,
				headers: {
					'Content-Type': 'application/json',
				},
			})

			if (response.ok) {
				return true
			}
		} catch (e) {
			captureException(new Error('Cannot send license agreement status to IDE'), {
				extra: { error: e },
			})
		}
	}

	return false
}
